import { Component, Input } from '@angular/core';
import { Queue, Faculty } from '../../../../models';

@Component({
    selector: 'qms-queues-tree-view',
    templateUrl: './queues-tree-view.component.html',
    styleUrls: ['./queues-tree-view.component.css']
})
export class QueuesTreeViewComponent {
    @Input()
    public queues: Queue[];

    @Input()
    public parent: Queue;

    @Input()
    public faculty: Faculty;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/queues/tree-view/queues-tree-view.component.ts